import { ReactNode } from 'react'

import classnames from 'classnames'

import './configMenuItem.scss'

export interface Props {
  children: ReactNode,
  isHighlighted?: boolean,
  onClick?: () => void
}

const ConfigMenuItem = ({ children, isHighlighted, onClick }: Props) => {
  return (
    <div data-test="container" onClick={onClick} className={classnames('config-menu-item', {
      'is-highlighted': isHighlighted
    })}>
      {children}
    </div>
  )
}

export default ConfigMenuItem
